import { Cloud, Eye, Link2, Link2Off } from "lucide-react";

import { isPrimaryLink } from "./cells";

import { RowMenu } from "@/components/kit";
import { ScrapedProduct } from "@/types/scraped-product";

/** The "…" menu of a scraped product: import it, link it to a catalog product, unlink it, or open the linked one. */
export function RowActions({
  product,
  importBlocked,
  onImport,
  onAssociate,
  onDisassociate,
}: {
  product: ScrapedProduct;
  importBlocked: boolean;
  onImport: () => void;
  onAssociate: () => void;
  onDisassociate: () => void;
}) {
  return (
    <RowMenu
      items={[
        {
          id: "import",
          label: "Import Product",
          icon: <Cloud className="size-4" />,
          isDisabled: importBlocked,
          onAction: onImport,
        },
        {
          id: "associate",
          label: "Associate",
          icon: <Link2 className="size-4" />,
          isDisabled: Boolean(product.product),
          onAction: onAssociate,
        },
        {
          id: "disassociate",
          label: "Disassociate",
          icon: <Link2Off className="size-4" />,
          isDisabled: !product.product || isPrimaryLink(product),
          onAction: onDisassociate,
        },
        ...(product.product
          ? [
              {
                id: "view-linked",
                label: "View Linked Product",
                icon: <Eye className="size-4" />,
                onAction: () =>
                  window.open(
                    `/products?name=${product.product!.name}`,
                    "_blank",
                  ),
              },
            ]
          : []),
      ]}
      label={`Actions for ${product.name}`}
    />
  );
}
